<script>
export default {
  name: "hurixPagination",
  props: {
    pageSizeOptions: {   // 分页选项
      type: Array,
      default:() => [10,20,30,40]
    },
    LastPage: {   //  是否最后一页
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pageSize: 10,
      page: 1,
    }
  },
  methods: {
    pageSizeChange(e) {
      this.page = 1;
      this.$emit('pageSizeChange', e);
    },
    pageChange(flag) {
      // left 上一页  right  下一页
      if(flag === 'left') {
        -- this.page;
      } else {
        ++ this.page;
      }
      this.$emit("pageChange", flag , this.page);
    }
  }
}
</script>

<template>
  <div class="hurixPagination">
    <el-select v-model="pageSize" class="page-size" size="small" @change="pageSizeChange">
      <el-option v-for="item in pageSizeOptions" :value="item" :label="item + $t('table.pageSize')" :key="item">
        {{ item }}{{$t("table.pageSize")}}
      </el-option>
    </el-select>
    <el-button icon="el-icon-arrow-left" size="small" :disabled="page === 1" @click="pageChange('left')"></el-button>
    <span class="page">{{page}}</span>
    <el-button icon="el-icon-arrow-right" size="small" :disabled="LastPage" @click="pageChange('right')"></el-button>
  </div>
</template>

<style scoped lang="scss">
.hurixPagination {
  margin-top: 20px;
  text-align: right;
  padding-right: 10px;
  .page-size {
    width: 100px;
    margin-right: 20px;
  }
  .page {
    margin: 0 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/hurixPagination/index.vue